import React, { useState, useEffect, useContext } from 'react';
import styles from './index.module.scss'
import { Collapse, message } from 'antd';
import FillLightBar from './fillLightBar'
import AiBeautyBar from './aiBeautyBar'
import MagicEraseBar from './magicEraseBar'
import HandRepairBar from './handRepairBar'
import Iconfont from '@utils/Iconfont';
import { AIEditContext } from '../AIEditContext';
import { AppContext } from '@utils/AppContext';

const EditLeftBar = (props) => {
    const {  setOperateType, setPaintSize,  setEraserSize, setModeState, AIEditLoading} = useContext(AIEditContext)
    const { selectPreset, url, lightLoadModule, lightSettingChange, oneClickBeauty,
        saveUndoList, faceArray, bodyArray, handleDraw, repairSizeChange, createClick,
    } = props
    const panelStyle = {
        marginBottom: 10,
        background: '#fff',
        borderRadius: '5px',
        border: 'none',
        with: '340px'
    }

    const mattingBox = (
        <div className={styles.mattingBox}>
            <div
                onClick={() => window.open(url ? `/home/image_extraction?url=${encodeURIComponent(url)}` : `/home/image_extraction`, '_blank')}
                className={styles.mattingBoxItem}>
                <span><Iconfont type="icon-mattingOutlined" className={styles.Icon} />智能抠图</span>
                <Iconfont type="icon-newpageOutlined" className={styles.Icon2} />
            </div>
            <div
                onClick={() => window.open(url ? `/home/imageResize?url=${encodeURIComponent(url)}` : `/home/imageResize`, '_blank')}
                className={styles.mattingBoxItem}>
                <span><Iconfont type="icon-picResizeOutlined" className={styles.Icon} />高清改尺寸</span>
                <Iconfont type="icon-newpageOutlined" className={styles.Icon2} />
            </div>
        </div>
    )

    const getItems = (panelStyle) => [
        {
            key: 'filllight',
            label: <p className={`${styles.title}`}><Iconfont type="icon-lightIconOutlined" className={styles.Icon} /> 智能补光</p>,
            children: <FillLightBar saveResult={props.saveResult} isFilter={false} selectPreset={selectPreset} url={url} lightLoadModule={lightLoadModule} lightSettingChange={lightSettingChange} />,
            style: panelStyle,
        }, {
            key: 'beautify',
            label: <p className={`${styles.title}`}><Iconfont type="icon-beautyIconOutlined" className={styles.Icon} />智能美化</p>,
            children: <AiBeautyBar saveResult={props.saveResult} oneClickBeauty={oneClickBeauty} url={url} saveUndoList={saveUndoList} faceArray={faceArray} bodyArray={bodyArray} />,
            style: panelStyle,
        }, {
            key: 'magicErase',
            label: <p className={`${styles.title}`}><Iconfont type="icon-magicIconOutlined" className={styles.Icon} />魔法擦除</p>,
            children: <MagicEraseBar url={url} handleDraw={handleDraw} repairSizeChange={repairSizeChange} createClick={createClick} />,
            style: panelStyle,
        }, {
            key: 'handRepair',
            label: <p className={`${styles.title}`}><Iconfont type="icon-handRepairOutlined" className={styles.Icon} />手部修复</p>,
            children: <HandRepairBar url={url} handleDraw={handleDraw} repairSizeChange={repairSizeChange} createClick={createClick} />,
            style: panelStyle,
        },
    ]

    const [activeKey, setActiveKey] = useState([props.activeKey])
    useEffect(() => {
        setOperateType('draw')
        setPaintSize(20)
        setEraserSize(20)
        setModeState('paint')
        setActiveKey([props.activeKey])
    }, [props.activeKey])

    const collapseChange = (val) => {
        if(AIEditLoading) {
            message.warning('请等待应用生效后操作！')
            return
        }
        if (val.length == 0) return
        setActiveKey(val)
        props.onClick({ key: val[0] })
        props.setOutputMask()
    }

    return (
        <div className={styles.editLeftBar}>
            {mattingBox}
            <Collapse
                accordion={true}
                bordered={false}
                activeKey={activeKey}
                expandIconPosition="end"
                expandIcon={({ isActive }) => <img className={isActive ? styles.rotate_sty : null} src={require('@assets/images/collapseIcon.png')} />}
                style={{
                    background: '#fff',
                }}
                items={getItems(panelStyle)}
                onChange={collapseChange}
            />
        </div>
    )

}

export default EditLeftBar